import { useEffect, useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useCampaignQuote = (wrap, months, drivers) => {
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    setQuote(null);
    setLoading(true);
    setError('');
    const timer = setTimeout(async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/public/quote`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ wrap_type: wrap, duration_months: months, drivers }),
          signal: controller.signal,
        });
        if (!response.ok) throw new Error('Quote unavailable');
        const result = await response.json();
        if (!controller.signal.aborted) setQuote(result);
      } catch (err) {
        if (!controller.signal.aborted) setError('Pricing is temporarily unavailable. Please try again.');
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    }, 250);
    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [wrap, months, drivers, attempt]);

  return { quote, loading, error, retry: () => setAttempt(value => value + 1) };
};